import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { AppBar, DialogContent, Table, TableBody, TableCell, TableHead, TableRow, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import ImprimirApp from "app/Core/Components/Imprimir/ImprimirApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import NumeroExtenso from "numero-por-extenso";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import XAPPButton from "../../Core/Components/Button/XAPPButton";
import * as Actions from "./Store/Actions/TarefaApontamentoActions";

const styles = theme => ({
   anotherLine: {
      backgroundColor: theme.palette.type === "dark" ? "#303030" : "#D4D4D4"
   }
});

const md = new MobileDetect(window.navigator.userAgent);

class TarefaApontamentoReciboDialog extends XAPPComponent {

   state = {
      descricaocomercial: ""
   };

   componentDidUpdate(prevProps) {
      const form = this.state;
      const { listRecibo, xappRouteParams, reciboDialog, recibos = null } = this.props;
      if (!_.isNull(reciboDialog) && _.isNull(prevProps.reciboDialog)) {
         listRecibo(xappRouteParams, reciboDialog);
      }

      if (form.descricaocomercial === "" && _.isNull(prevProps.recibos) && !_.isNull(recibos)) {
         this.setState(_.set({ ...form }, "descricaocomercial", _.find(recibos, x => !_.isNull(x.descricaocomercial))?.descricaocomercial ?? ""));
      }

      if (form.descricaocomercial !== "" && _.isNull(recibos)) {
         this.setState(_.set({ ...form }, "descricaocomercial", ""));
      }

   }

   handleChange = (event) => {
      this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
   };

   handleLookupEmpresaInsumo = (_AValue) => {
      var obj = this.state;
      if (_AValue) {
         obj["idpessoaformulario"] = _AValue["idpessoaformulario"];
         obj["nome"] = _AValue["nome"];
         obj["unidademedidadescricao"] = _AValue["unidademedida"];
         obj["valor"] = _AValue["valor"];
         this.setState(obj);
      } else {
         obj["idpessoaformulario"] = null;
         obj["nome"] = null;
         obj["unidademedidadescricao"] = null;
         obj["valor"] = null;
         this.setState(obj);
      }
   };

   handleLookupEmpresaPessoa = (_AValue = []) => {
      var obj = this.state;
      if (_AValue.length > 0) {
         obj["idpessoaformulario"] = _AValue[0].idpessoaformulario;
         obj["nome"] = _AValue[0].nome;
         this.setState(obj);
      } else {
         obj["idpessoaformulario"] = null;
         obj["nome"] = null;
         this.setState(obj);
      }
   };

   canBeSubmitted() {
      const form = this.state;
      return (!_.isNull(form.descricaocomercial) && form.descricaocomercial !== "");
   }

   getColumns = () => {
      return [
         { "header": "ID", "accessor": "idtarefaprocessoapontamentoitem", "align": "center" },
         { "header": "Data", "accessor": "datainsdescricao", "align": "center" },
         { "header": "Valor", "accessor": "valortotaldescricao", "align": "right" },
         { "header": "Imprimir", "accessor": "imprimir", "align": "center" }
      ];
   };

   getDados = (_AData) => {
      const form = this.state;
      const { profissional } = this.props;
      let ADados = { ..._AData };
      ADados.descricaocomercial = form.descricaocomercial;
      ADados.valortotaldescricao = `${ADados.valortotaldescricao} (${NumeroExtenso.porExtenso(ADados.valortotal, NumeroExtenso.estilo.monetario)})`;

      ADados.profissional_nome = profissional.nome;
      ADados.profissional_documentoprimario = profissional.formulario?.documentoprimario ?? "";
      ADados.profissional_registroconselho = profissional.formulario?.registroconselho ?? "";
      ADados.profissional_registroconselhouf = profissional.formulario?.registroconselhouf ?? "";

      return JSON.stringify(ADados);
   };

   checkDadosPendentes = (_AData) => {
      const ADados = JSON.parse(this.getDados(_AData));

      return (_.isNull(ADados.nome) || ADados.nome === "" ||
         _.isNull(ADados.documentoprimario) || ADados.documentoprimario === "" ||
         _.isNull(ADados.profissional_nome) || ADados.profissional_nome === "" ||
         _.isNull(ADados.profissional_documentoprimario) || ADados.profissional_documentoprimario === "" ||
         _.isNull(ADados.profissional_registroconselho) || ADados.profissional_registroconselho === "" ||
         _.isNull(ADados.profissional_registroconselhouf) || ADados.profissional_registroconselhouf === "");
   };

   showDadosPendentes = (_AData) => {
      const ADados = JSON.parse(this.getDados(_AData));
      const { showMessage } = this.props;
      if (_.isNull(ADados.documentoprimario) || ADados.documentoprimario === "") {
         showMessage({ message: "Número de CPF obrigatório para emissão do recibo.", variant: "error" });
      }
      if (_.isNull(ADados.profissional_nome) || ADados.profissional_nome === "" ||
         _.isNull(ADados.profissional_documentoprimario) || ADados.profissional_documentoprimario === "" ||
         _.isNull(ADados.profissional_registroconselho) || ADados.profissional_registroconselho === "" ||
         _.isNull(ADados.profissional_registroconselhouf) || ADados.profissional_registroconselhouf === "") {
         showMessage({ message: "Número de CPF e dados do conselho do profissional obrigatório para emissão do recibo.", variant: "error" });
      }
   };

   render() {
      const { reciboDialog, save, xappRouteParams, openReciboDialog, recibos = null, classes, foreingKey } = this.props;
      const form = this.state;

      return (
         <XAPPDialog
            id="TarefaApontamentoNovo"
            open={!_.isNull(reciboDialog)}
            onClose={() => openReciboDialog()}
            fullWidth
            fullScreen={md.mobile() !== null}
            maxWidth={md.mobile() === null && md.tablet() === null && "sm"}
         >
            <AppBar position="static" elevation={1}>
               <Toolbar className="flex w-full min-h-0">
                  <Typography variant="subtitle1 text-white">{"Lista de titulos"}</Typography>
                  <div style={{ flex: 1 }} />
                  <XAPPButton
                     className="p-8 "
                     icon="close"
                     type="icon"
                     iconProps="text-24"
                     onClick={() => openReciboDialog()}
                  />
               </Toolbar>
            </AppBar>
            <DialogContent classes={{ root: "p-12" }}>
               <React.Fragment>
                  <TextField
                     className=""
                     label="Descrição do recibo"
                     id="descricaocomercial"
                     name="descricaocomercial"
                     variant="outlined"
                     fullWidth
                     value={form.descricaocomercial}
                     onChange={this.handleChange}
                     multiline
                     rows={3}
                     InputLabelProps={{
                        shrink: true,
                     }}
                  />
               </React.Fragment>
               <div className="flex my-12 justify-center items-center">
                  <XAPPButton
                     type="Button"
                     className="bg-green hover:bg-green text-white"
                     variant="contained"
                     color="primary"
                     disabled={!this.canBeSubmitted()}
                     onClick={() => {
                        save("ATUALIZAR-RECIBO", { ...form, "idpedido": reciboDialog }, xappRouteParams, foreingKey);
                     }}
                     iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                     icon={"save"}
                     label={md.mobile() === null && md.tablet() === null ? "SALVAR" : ""}
                  />
               </div>
               {!_.isNull(recibos) &&
                  <React.Fragment>
                     <FuseAnimate>
                        <Table className="min-w-full" aria-labelledby="tableTitle">
                           <TableHead>
                              <TableRow className="h-64">
                                 {this.getColumns().map(column => (
                                    <TableCell
                                       key={column.accessor}
                                       align={"center"}
                                       style={{ padding: "2px 12px 2px 12px" }}
                                    >
                                       {column.header}
                                    </TableCell>
                                 ))}
                              </TableRow>
                           </TableHead>
                           <TableBody>
                              {recibos.map((n, y) => (
                                 <TableRow key={y} className={clsx("", y % 2 === 0 && classes.anotherLine)}>
                                    {this.getColumns().map((column, x) => (
                                       <TableCell key={x} component="th" scope="row" style={{ padding: "2px 12px 2px 12px" }} align={column.align} >
                                          {column.accessor === "imprimir" ?
                                             <React.Fragment>
                                                {!this.checkDadosPendentes(n) ?
                                                   <ImprimirApp
                                                      type="Icon"
                                                      xappRouteParams={xappRouteParams}
                                                      data={this.getDados(n)}
                                                      key="btnImprimir"
                                                      id="btnImprimir"
                                                      label={"Recibo"}
                                                      idrelatorio={"116"}
                                                      disabled={_.isNull(form?.descricaocomercial) || form.descricaocomercial === ""}
                                                      className="h-32 w-32 p-6 text-blue"
                                                   />
                                                   :
                                                   <XAPPButton
                                                      type="Icon"
                                                      className={"text-blue"}
                                                      onClick={() => this.showDadosPendentes(n)}
                                                      variant="contained"
                                                      icon="print"
                                                      label={"Imprimir"}
                                                      tooltip={{ "title": "Imprimir", "placement": "top" }}
                                                   />
                                                }
                                             </React.Fragment>
                                             :
                                             n[column.accessor]
                                          }
                                       </TableCell>
                                    ))}
                                 </TableRow>
                              ))}
                           </TableBody>
                        </Table>
                     </FuseAnimate>
                  </React.Fragment>
               }
            </DialogContent>
         </XAPPDialog>
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators(
      {
         listRecibo: Actions.listRecibo,
         openReciboDialog: Actions.openReciboDialog,
         save: Actions.save,
         showMessage: AppActions.showMessage,
      }, dispatch);
}

function mapStateToProps({ TarefaApontamento }) {
   return {
      reciboDialog: TarefaApontamento.reciboDialog,
      recibos: TarefaApontamento.recibos,
   };
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(TarefaApontamentoReciboDialog));
